import { render, staticRenderFns } from "./RelatedOwnerSelectModal.vue?vue&type=template&id=331779ed&"
import script from "./RelatedOwnerSelectModal.vue?vue&type=script&lang=ts&"
export * from "./RelatedOwnerSelectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports